const isPaidUser = (membership) => {
  return !!membership && membership !== 'expired'
}

export default isPaidUser
